import PropTypes from 'prop-types';
import React from 'react';
// import ReactModal from 'react-modal';
import Draggable from 'react-draggable'
import bindAll from 'lodash.bindall';
import { connect } from 'react-redux';
import tabStyles from 'react-tabs/style/react-tabs.css';
import styles from './modal.css';
import classNames from 'classnames';
import BoardImg from './handpy-board.png'
import Empty from './empty.png'
import { closeHandpyWebsiteModal } from '../../reducers/modals';


class ModalComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'closeModal',
            'handleChange',
            'handleModalSizeChange',
            'handleScrollHeightChange'
        ]);
        this.state = {
            tableData: [],
            activeTabIndex: 0,
            blockData: {
                openChartWindow: false,
                setChartTitle: '未命名',
                setChartType: 'table',
                setRenderSpeed: 'no_delay',
                setAxisTitle: {},
                setRightYTitle: '右y轴',
                setDataGroup: {},
                inputVariables: {},
                inputVariablesTerm: {}
            },
            type: 'line',
            isLarge: false,
            scrollHeight: 0
        };
    }
    // 数据处理
    componentWillReceiveProps (nextProps) {
        this.handleScrollHeightChange();
        // console.log('nextProps -- ', nextProps)
    }

    onStart (e) {
    };
    handleDrag (e) {
    };
    onStop () {
    };
    // 下拉选框切换
    handleChange (e) {
        this.setState({
            blockData: Object.assign({}, this.state.blockData, {
                setChartType: e.target.value
            }),
            type: e.target.value
        })
    }
    // 缩放功能
    handleModalSizeChange () {
        this.setState({
            isLarge: !this.state.isLarge
        })
    }
    closeModal () {
        this.props.onRequestClose();
    }

    handleScrollHeightChange () {
        // console.log('this.resizeBox ? ', this.resizeBox)
        if (!this.resizeBox) {
            return false;
        }
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            const {scrollHeight, clientHeight} = this.resizeBox;
            if (scrollHeight != this.state.scrollHeight) {
                this.setState({scrollHeight});
                this.resizeBox.scrollTop = scrollHeight - clientHeight;
            }
            this.timer = null;
        }, 300);
    }

    handleStart () { }
    handleStop () { }
    render () {
        const {
            handpySiotTopic1, handpySiotTopic2, handpySiotTopic3,
            handpySiotTopic1Data, handpySiotTopic2Data, handpySiotTopic3Data,
            closeHandpyWebsiteModal
        } = this.props
        let handpySiotTopic, handpySiotTopicData;
        if (handpySiotTopic3) {
            handpySiotTopic = handpySiotTopic3
            handpySiotTopicData = handpySiotTopic3Data
        }
        if (handpySiotTopic2) {
            handpySiotTopic = handpySiotTopic2
            handpySiotTopicData = handpySiotTopic2Data
        }
        if (handpySiotTopic1) {
            handpySiotTopic = handpySiotTopic1
            handpySiotTopicData = handpySiotTopic1Data
        }

        return (
            <div className="draggable_box">
                <Draggable
                    onStart={this.handleStart}
                    onDrag={this.handleDrag}
                    onStop={this.handleStop}
                >
                    <div className={styles.modalWebsiteChart} >
                        
                        <span
                            className={styles.closeModal}
                            onClick={closeHandpyWebsiteModal}
                        >×</span>

                        <div className={styles.websiteBox} >
                            <p className={styles.headerTitle}>SIoT</p>
                            <p className={styles.topicTitle}>当前主题: {handpySiotTopic}</p>
                            <table className={styles.chart_table} border='1px'>
                                <thead className={styles.table_head}>
                                    <tr>
                                        <th>噪声值</th>
                                        <th>时间</th>
                                    </tr>
                                </thead>
                                <tbody
                                    className={styles.table_body}
                                    style={{height: 'calc(100vh - 595px)'}}
                                    ref={el => {
                                        this.resizeBox = el;
                                    }}
                                >
                                    {handpySiotTopicData && handpySiotTopicData.map((v, i) => {
                                        return (<tr key={i}>
                                            <td>{v.message}</td>
                                            <td>{new Date(v.timestamp).Format('yyyy-MM-dd hh:mm:ss')}</td>
                                        </tr>);
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Draggable>
            </div>
        );
    }
}


ModalComponent.propTypes = {
    closeHandpyWebsiteModal: PropTypes.func,
    handpySiotTopic1: PropTypes.string,
    handpySiotTopic2: PropTypes.string,
    handpySiotTopic3: PropTypes.string,
    handpySiotTopic1Data: PropTypes.array,
    handpySiotTopic2Data: PropTypes.array,
    handpySiotTopic3Data: PropTypes.array,
    // onButtonAction: PropTypes.func,
    // handpyBoardButtonAction: PropTypes.func
    // tags: PropTypes.arrayOf(PropTypes.shape(TagButton.propTypes)),
    // title: PropTypes.string.isRequired
}
const mapStateToProps = state => ({
    handpySiotTopic1: state.scratchGui.modals.HANDPY_SIOT_TOPIC1,
    handpySiotTopic2: state.scratchGui.modals.HANDPY_SIOT_TOPIC2,
    handpySiotTopic3: state.scratchGui.modals.HANDPY_SIOT_TOPIC3,
    handpySiotTopic1Data: state.scratchGui.modals.HANDPY_SIOT_TOPIC1_DATA,
    handpySiotTopic2Data: state.scratchGui.modals.HANDPY_SIOT_TOPIC2_DATA,
    handpySiotTopic3Data: state.scratchGui.modals.HANDPY_SIOT_TOPIC3_DATA
});

const mapDispatchToProps = dispatch => ({
    closeHandpyWebsiteModal: () => dispatch(closeHandpyWebsiteModal())
});

export default connect(
    mapStateToProps,
    // mapDispatchToProps
    mapDispatchToProps
)(ModalComponent);
